/*
  Prevent warning:
  `value` prop on `input` should not be null.

  Consider using an empty string to clear the component or `undefined` for uncontrolled components
*/

const normalizeFormData = formData => {
  if (!formData) {
    return {};
  }

  return Object.keys(formData).reduce((acc, key) => {
    if (formData[key] === null) {
      return { ...acc, [key]: '' };
    }

    return { ...acc, [key]: formData[key] };
  }, {});
};

export default normalizeFormData;
